module.exports = __webpack_public_path__ + "img/ic-data-3.bcf4b2be.svg";